export default __webpack_public_path__ + "static/media/icon-cm-alert.7fc00533.svg";